import React, {useState, useEffect, useContext} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
// import ComSingleRa from './ComSingleRa';
// import Switch from "react-switch";
import ToggleButton from 'react-toggle-button'



function ComRa(){
  const [state, actions] = useContext(UserContext);
  const [ralist, setRalist] = useState(null)
  const [btn, setBtn] = useState(true)

  let user = JSON.parse(String(localStorage.getItem('user')))
  const header = {Authorization: `JWT ${user.token}`}

  let apilink = ''

  if(localStorage.getItem("is_headhunter") === "true") apilink = "/api/rahh/"
  else if (localStorage.getItem("is_recruiter") === "true") apilink = "/api/ra/"

  function fetchActive(id, status){
    fetch(state.awslink + '/api/raactive/', {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "id": id,
        "status": status
      })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
      })
  }
  

  useEffect(()=>{
    async function fetchRalist(){
      const res =  fetch(state.awslink + apilink, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        
        let newobj = [];
        if(localStorage.getItem("is_headhunter") === "true"){
          if(json["ra"])
            if(json["ra"].length)
              {json["ra"].map((item, index)=>{
                newobj.push(item)
              })}

          setRalist(newobj)
        }
        else if (localStorage.getItem("is_recruiter") === "true")
          setRalist(json)

      }
      )
    }
    
    if(ralist === null)
      fetchRalist();
    
  }, [ralist, btn,])
  console.log(ralist)
  
  // if(ralist === null){
  //   console.log("fetch2")
  //   if(state.token != undefined)
  //     fetchRalist();
  // }
  
  return(
    <>
    {/* {console.log("render")} */}
    {state.width < state.breakpoint ? 
      null
    :
      <Wrapper>
        
        <RaWrapper>
          <CardWrapper>
            <CardAdd>
              <div style={{justifyContent: 'center', alignItems: 'center'}}> 
                <Link to={'/recruiter/raadd'}>
                  <div>+</div></Link>
              </div>
            </CardAdd>

            {ralist ? 
              ralist.length && 
              ralist.map((item, index)=>{
                console.log(index, item.active)
                return(
                <Card>
                  <div>
                  <Active style={{zIndex: 5, width:20}}
                    onClick={()=>{
                      fetchActive(item.id, item.status)
                      item.active = !item.active
                      setBtn(!btn)
                      }}>
                    
                      {item.active?
                      "T" : "F"}

                  </Active>
                  <Link to={'/recruiter/ra/'+ item.id + '/' + item.title}> 
                    <div>
                      <div className={'qu-title'}>{item.title}</div>
                      <div className={'qu-subtitle'}>{item.field}</div>
                      <div className={'qu-subtitle'}>{item.job}</div>
                      {/* <div>{item.description}</div> */}
                      <div className={'qu-add'}>{item.status}</div>
                      {/* <div>{item.active}</div> */}
                      
                      {/* <div>{item.salary}</div> */}
                      {/* <div>{item.workyears}</div> */}
                      <div className={'qu-add'}>{item.created.split('T')[0]}</div>
                      {/* <div>{item.views}</div> */}
                    </div>
                  </Link>
                  
                  {/* <div>{item.applicant}</div> */}
                  </div>
                </Card>)
              })
            :null}
          
          

          </CardWrapper>
        </RaWrapper>
      </Wrapper>   
      }
    </>
  )
}

// const Wrapper = styled.div`
//   width: 100%;
//   display: flex;
//   height: 100%;
//   /* border: solid green; */
//   justify-content: center;
//   align-items: center;
//   background-color: whitesmoke;
// `

// const RaWrapper = styled.div`
//   width: 100%;
//   max-width: 980px;
//   display: flex;
//   min-height: calc(100vh - 45px);
//   height: 100%;
//   /* border: solid green; */
//     /* flex-direction: column; */
//   justify-content: flex-start;
//   align-items: flex-start;
//   margin-top: 45px;
//   background-color: whitesmoke;

//   flex-flow: row wrap;
//   /* align-content: space-between;
//   justify-content: space-between; */
//   flex-grow: 4;
// `

// const Card = styled.div`
//   /* width: 25%; */
//   width: 221px;
//   /* max-width: 240px; */
//   height: 220px;
//   border: rgba(0,0,0,0.5) 2px solid;
//   border-radius: 7px;
//   margin: 10px;

//   display: flex;
//   /* flex-wrap: wrap; */
//   /* flex-grow: 4; */
//   justify-content: flex-start;
  
//   align-items: flex-start;
//   flex-direction: column;
//   position: relative;

  
  
//   :nth-child(5){
//     /* background-color:green; */
//     break-after: always;
//   }
//   >a{
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     /* z-index:2; */
//   }
// `

const Active = styled.div`
  position: absolute;
  /* width: 20px;
  height: 20px; */
  bottom: 0;
  right: 0px;
  display:flex;
  justify-content: center;
  align-items:center;

  z-index:1;
`


const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  /* margin-top: 45px; */
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: block;
  margin: 0 auto;
  background-color: whitesmoke;
`

const CardWrapper = styled.ul`
  padding: 0;
  content: " ";
  display: table;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  list-style: none;
  list-style-position: outside;
  
  margin: -10px;
  margin-top: 10px;
  width: calc(100% + 20px);
`

const CardAdd = styled.li`
  width: 25%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  display: inline-block;
  /* padding-bottom: 56.25%; */
  height: calc(25vw * .6);
  min-height: 200px;
  padding: 10px;
  float: left;
  vertical-align: top;
  
  @media (max-width: 768px){
    width: 50%;
  }

  >div{
    border: 0.5px solid rgba(0,0,0,0.2);
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;

    >a{
      display: flex;
      justify-content: center;
      align-items: center;
      
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;

      text-decoration: none;
    
      >div{
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background-color: rgba(253,134,18, 0.8);
        /* background-color: rgba(0,0,0, 0.2); */

        color: white;

        border-radius: 50px;
        width: 70px;
        height: 70px;
      }
    }
  }
`

const Card = styled.li`
  width: 25%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  display: inline-block;
  /* padding-bottom: 56.25%; */
  height: calc(25vw * .6);
  min-height: 200px;
  padding: 10px;
  float: left;
  vertical-align: top;
  
  @media (max-width: 768px){
    width: 50%;
  }

  >div{
    border: 0.5px solid rgba(0,0,0,0.2);
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;
    position: relative;
    >a{
    display: block;
    
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;

    text-decoration: none;
    >header{
      height: 60%;
      background-position-x:50%;
      background-position-y:50%;
      background-size: cover;
      
    }
    >div{
      cursor: pointer;
      color: black;
      padding: 10px;
      
      >div{
        text-align: left;
      }
    }
  }
  }
  
`

export default ComRa